import BingPixel from './BingPixel';

export default BingPixel;
